<template>
  <div class="tab-pane fade" id="sum-content" role="tabpanel" aria-labelledby="sum-content-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">位置</label>
          <select class="form-control" v-model.number="selectEntrance">
            <option value="-1">全部</option>
            <option v-for="(list, index) in entranceList" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">交通工具型態</label>
          <select class="form-control" v-model.number="selectVehicleType">
            <option value="-1">全部</option>
            <option v-for="(list, index) in vehicleTypeList" :key="index" :value="list.id">{{ list.description }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryTrafficFlow"
            :disabled="isWaitResult">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaitResult">
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">統計</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="sumAreaCar" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">日期</th>
                    <th scope="col">位置</th>
                    <th scope="col">車種</th>
                    <th scope="col">進入數量/平均車速(km/h)</th>
                    <th scope="col">離開數量/平均車速(km/h)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in trafficFlowList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.entrance }}</td>
                    <td>{{ item.vehicleType }}</td>
                    <td>{{ item.amountAndSpeedIn }}</td>
                    <td>{{ item.amountAndSpeedOut }}</td>

                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      entranceList: CONST.TRAFFIC_ENTRANCE_ENUM,
      vehicleTypeList: CONST.TRAFFIC_VEHICLE_TYPE_ENUM,
      selectEntrance: -1,
      selectVehicleType: -1,
      trafficFlowList: [],
      startTime: moment(moment().clone().startOf("month").format("YYYY-MM-DD hh:mm")).format(), //vue-datetime-24period,
      endTime: moment(moment().clone().startOf("day").format("YYYY-MM-DD hh:mm")).format(), //vue-datetime-24period,
      isWaitResult: false,
      maxSelectTime: Utils.getLastestTime(),

    };
  },
  watch: {

  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),

  },
  methods: {
    getTableAreaName(name) {
      if (Utils.isEmptyObject(name))
        return this.searchAreaName

      return name
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    async queryCSV() {
      this.isWaitResult = true
      const trafficFlowList = await this.searchTrafficFlow()

      const csvContent = [['日期', '位置', '車種', '進入數量/平均車速(km/h)', '離開數量/平均車速(km/h)']]
      trafficFlowList.forEach(item => {
        const row = []
        row.push(item.date)
        row.push(item.entrance)
        row.push(item.vehicleType)
        row.push(item.amountAndSpeedIn)
        row.push(item.amountAndSpeedOut)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_轄區車流_統計.csv`
      exportCSV.genCSVFile(csvContent, fileName)

      this.isWaitResult = false
    },

    async queryTrafficFlow() {
      this.isWaitResult = true
      this.trafficFlowList = await this.searchTrafficFlow()
      this.updateTable()

      this.isWaitResult = false
    },

    async searchTrafficFlow() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return []
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return []
      }

      const st = moment(this.startTime).startOf('d').valueOf()
      const et = moment(this.endTime).endOf('d').valueOf()
      // const et = moment(this.endTime).add(1, 'd').startOf('d').valueOf()

      const condition = {
        startTime: st,
        endTime: et,
        roadEntranceId: this.selectEntrance,
        vehicleType: this.selectVehicleType
      }

      await this.$store.dispatch('trafficFlow/GetDailyTrafficFlowData', condition)
      const dataList = this.$store.getters['trafficFlow/getTrafficFlow']

      // const withoutMoto = dataList.filter(d => d.vehicleType !== CONST.VD_VEHICLE_TYPE_ID.M) // 不要機車
      const trafficFlowList = this.groupByTime(dataList)

      return this.handleTrafficFlow(trafficFlowList)
    },

    handleTrafficFlow(trafficFlowList) {
      const result = []
      const total = {
        date: '統計',
        entrance: '',
        vehicleType: '',
        amountAndSpeedIn: '',
        amountAndSpeedOut: '',
        inTotalCount: 0,
        outTotalCount: 0,
        inSpeed: 0,
        outSpeed: 0
      }

      trafficFlowList.forEach(item => {
        const data = {
          date: '',
          entrance: '',
          vehicleType: '',
          amountAndSpeedIn: '',
          amountAndSpeedOut: ''
        }

        const inData = item.flow.find(f => f.driveDirection === CONST.VD_DETECTION_ID_AREA_CAR.IN)
        const outData = item.flow.find(f => f.driveDirection === CONST.VD_DETECTION_ID_AREA_CAR.OUT)

        data.date = inData ? this.getTime(inData) : outData ? this.getTime(outData) : '-'
        data.entrance = inData ? this.getEntrance(inData) : outData ? this.getEntrance(outData) : '-'
        data.vehicleType = inData ? this.getVehicleType(inData) : outData ? this.getVehicleType(outData) : '-'
        data.amountAndSpeedIn = inData ? `${inData.totalCount}/${Math.round(inData.averageSpeed)}` : '-'
        data.amountAndSpeedOut = outData ? `${outData.totalCount}/${Math.round(outData.averageSpeed)}` : '-'


        total.inTotalCount = total.inTotalCount + inData.totalCount
        total.outTotalCount = total.outTotalCount + outData.totalCount
        total.inSpeed = total.inSpeed + inData.averageSpeed
        total.outSpeed = total.outSpeed + outData.averageSpeed


        result.push(data)
      })

      total.amountAndSpeedIn = `${total.inTotalCount}/${Math.round((total.inSpeed/trafficFlowList.length)*10)/10}`
      total.amountAndSpeedOut = `${total.outTotalCount}/${Math.round((total.outSpeed/trafficFlowList.length)*10)/10}`

      result.push(total)
      return result
    },

    groupByTime(dataList) {
      const dateGroupBy = Utils.arrayGroupBy(dataList, 'startTime', 'trafficFlowList')
      return this.groupByEntrances(dateGroupBy)
    },

    groupByEntrances(dateGroupBy) {
      let result = []
      dateGroupBy.forEach(d => {
        const entrancesGroupBy = Utils.arrayGroupBy(d.trafficFlowList, 'roadEntranceId', 'Entrances')
        const groupByVehicle = this.groupByVehicleType(entrancesGroupBy)
        result = result.concat(groupByVehicle)
      })

      return result
    },

    groupByVehicleType(entrancesGroupBy) {
      let result = []
      entrancesGroupBy.forEach(entrance => {
        const vehicleTypeGroupBy = Utils.arrayGroupBy(entrance.Entrances, 'vehicleType', 'flow')
        result = result.concat(vehicleTypeGroupBy)
      })

      return result
    },

    getEntrance(item) {
      const target = CONST.TRAFFIC_ENTRANCE_ENUM.find(e => e.id == item.roadEntranceId)
      return target.description
    },

    getVehicleType(item) {
      const target = CONST.TRAFFIC_VEHICLE_TYPE_ENUM.find(e => e.id === item.vehicleType)
      return target.description
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.startTime)) {
        return "-";
      }

      const time = moment(item.startTime)
      return `${time.format('YYYY/MM/DD')}`
    },

    initTable: function () {
      this.table = $("#sumAreaCar").DataTable({
        aoColumns: [
          ...new Array($("#sumAreaCar th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: '/json/dataTableZHTW.json'
        },
        "pageLength": 25,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable()
  }
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody>tr>td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */</style>
